var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.pageType === 'boardMode')?_c('AIControl'):_vm._e(),(_vm.pageType === 'aiEyes')?_c('AIEyes'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }